import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { ActivityMetricsHeader } from '@/features/learning-metrics/components/ActivityMetricsHeader';
import { ActivityMetricsRoot } from '@/features/learning-metrics/components/ActivityMetricsRoot';
import { activityViewSearchParams } from '@/features/learning-metrics/hooks/useActivityViewSearch';
import { AppPageContent } from '@/features/shared/components/AppPageContent';

export const Route = createFileRoute('/_app/app/learning-metrics')({
  component: RouteComponent,
  validateSearch: zodValidator(activityViewSearchParams),
  ssr: false,
});

function RouteComponent() {
  return (
    <AppPageContent>
      <ActivityMetricsHeader />
      <ActivityMetricsRoot />
    </AppPageContent>
  );
}
